import { Component, OnInit, ViewChild } from "@angular/core";
import { AuthenticationService } from "../../../others/services/authentication.service";
import { isAfter, isBefore, isEqual } from "date-fns";
import { GeneralService } from "../../../services/general.service";
import "jquery";
import { KeyMetricsService } from "src/app/others/services/key-metrics.service";
import { CurrencyService } from "src/app/others/services/currency.service";
import { NgxSpinnerService } from "ngx-spinner";
import { getGlobalUserInfo } from 'src/app/others/auth/auth-storage';
import Swal from 'sweetalert2';
declare let $: any;


@Component({
  selector: "app-performance",
  templateUrl: "./performance.component.html",
  styleUrls: ["./performance.component.scss"],
})
export class PerformanceComponent implements OnInit {


  @ViewChild("modalView") viewModal;
  userInfo = getGlobalUserInfo();
  performanceList: any = [];
  yearlyPerformanceList: any = [];
  searchedPerformanceList: any = [];
  specimenList: any = [];
  clusters: any = [];
  selectedSpecimen: any;


  singleCurrency = "";
  currencyNme: any;
  currencySym: any;
  currencyBase: any;
  companyData: any;
  p = 0;
  detailPage = 0;
  searchVal = false;
  loading = false;
  newStartDate: any;
  newEndDate: any;
  allTime: string = 'All Time';


  fromDate: any;
  toDate: any;
  year = new Date().getFullYear();
  getAllServiceClusters: any;
  getAllBilling: any;


  detailedItem: any = [];
  calculatedTotalArreas: number;
  calculatedTotalBilled: any;
  calculatedTotalPaid: any;
  tab = "pathology";
  dtOptions: DataTables.Settings = {};
  permissions: any = { performance: { view: false, edit: false, add: false, print: false, delete: false } };
  searchText: "";


  constructor(
    public auth: AuthenticationService,
    private spinner: NgxSpinnerService,
    private generalService: GeneralService,
    private keyMetrics: KeyMetricsService,
    private currencyService: CurrencyService
  ) { }


  ngOnInit() {
    this.getPermissions();
    this.getPerformances();
    this.currencyService.conversionState$.subscribe(state => {
      this.currencySym = state.symbol;
      this.currencyNme = state.code;
      this.currencyBase = state.code === 'GH₵' ? 'GHS' : state.code;
    });
    this.getComProfile();
    this.getinfomodal();






  }
  // Get user permissions
  getPermissions() {
    if (this.auth.isGodMode()) {
      this.permissions = {
        performance: { view: true, edit: true, add: true, print: true, delete: true }
      };
      return;
    }


    this.permissions = {
      performance: {
        view: false
      },
    };


    this.auth
      .get("user_permissions/" + (this.userInfo?.id || sessionStorage.getItem("userID"))).toPromise()
      .then(
        (response: any) => {
          const fetched = response?.permissions?.permissions?.[0] || {};
          this.permissions = { ...this.permissions, ...fetched };
        },
        (error: any) => {


        }
      );
  }
  //get api get data base on radiology and pathology


  userArray(str) {
    return (str || ",,").trim().split(",");
  }


  getinfomodal(): void {
    const infoIcon = document.querySelector('#info-icon') as HTMLElement;
    const infoModal = document.querySelector('#info-modal') as HTMLElement;


    if (!infoIcon || !infoModal) {
      //  console.error('Could not find info-icon or info-modal elements');
      return;
    }


    infoIcon.addEventListener('mouseenter', () => {
      infoModal.style.display = 'block';
    });


    infoIcon.addEventListener('mouseleave', () => {
      infoModal.style.display = 'none';
    });
  }


  getPerformances() {
    // this.spinner.show();
    this.auth.get("item_performance").subscribe((response: any) => {
      this.getAllServiceClusters = response['service_cluster'];
      this.getAllBilling = response['billing']
      this.getIndexedData()


      const a = [];
      // response.form_name="Wilms Tumor,Ovarian Cancer, Prostate Turp, Prostate Cancer, Nephrectomy, Mastectomy, Laryngectomy, General Specimen, General Biopsy, Gastrectomies, Endometrial, Colon Specimen, Cervical Cancer, Breast Core Biopsy, Nongynaecytology, Prostatectomy, Leiomyomata, Immunohistochemistry Special Stains, Pap Request, Testecular Biopsy, Ultra Sound Ostetrics, Ultra Sound Obstetrics Report Twin, General Radiology Specimen, Ultra Sound Obstetrics Report Anomally, Cervical Spine, Right Shoulder Joint, Plain Radiology Pelvis, General Cancer Biopsies, Renal Core Icision Biopsy ")


      for (const res of response) {
        a.push(...res);
      }


      this.searchedPerformanceList = this.performanceList = a;


      this.getServiceCluster();
      this.getSpecimenList();
    });
    this.spinner.hide();
  }


  onTabChange(tab: string) {
    if (tab !== this.tab) {
      this.tab = tab;
      //   this.keyMetrics.getCount(this.tab)
      //   this.keyMetrics.keyMetrics.subscribe({
      //   next: (response) => {
      //   }
      // })
      this.clear();


      // //get api get data base on radiology, pathology and clinical lab
      this.auth.get(`item_performance?${tab}=${tab}&start_date=${this.newStartDate}&end_date=${this.newEndDate}`).subscribe({
        next: (response) => {
          this.detailedItem = []
          this.getAllServiceClusters = response['service_cluster'];
          this.getAllBilling = response['billing']
          // this.keyMetrics.getCount(this.getAllBilling)
          // this.getKeyMetricsCount()




          this.getIndexedData();
        },
        error: (error) => {
        }
      })


    }
  }


  getKeyMetricsCount() {
    this.keyMetrics.keyMetrics.subscribe({
      next: (response) => {
      }
    })


  }


  getIndexedData() {
    let arreas = 0;
    let amount_paid = 0;
    let total_amount = 0;
    let cases = 0;
    let newData = {};
    let all = []
    for (let i = 0; i < this.getAllBilling.length; i++) {
      arreas = this.getAllBilling[i]?.map((a) => a.arreas).filter((b) => b !== undefined)?.reduce((c, d) => c + d, 0)
      cases = this.getAllBilling[i]?.length
      amount_paid = this.getAllBilling[i]?.map((a) => a.amount_paid).filter((b) => b !== undefined)?.reduce((c, d) => c + d, 0)
      total_amount = this.getAllBilling[i]?.map((a) => a.total_amount).filter((b) => b !== undefined)?.reduce((c, d) => c + d, 0)
      if (this.getAllBilling[i]) {
        newData = {
          form_name: this.getAllBilling[i][0]?.form_name,
          arreas,
          cases,
          amount_paid,
          total_amount,
          spec_details: this.getAllBilling[i]
        }
      }


      this.detailedItem.push(newData)




    }


    // this.detailedItem = all


    this.getTotalDisplay();
  }


  getTotalDisplay() {
    //[170, 400, 19990, 5000]
    const arreas = this.detailedItem.map((a) => a.arreas)


      .reduce((b, c) => b + c, 0)


    this.calculatedTotalArreas = arreas


    //  total amount


    const billed = this.detailedItem.map((a) => a.total_amount)
      .reduce((b, c) => b + c, 0)


    this.calculatedTotalBilled = billed


    const paid = this.detailedItem.map((a) => a.amount_paid)
      .reduce((b, c) => b + c, 0)


    this.calculatedTotalPaid = paid


    // amount paid
  }


  getSpecimenList() {
    const lists = this.searchedPerformanceList;
    const a = [];
    const b = [];


    for (const list of lists) {
      const specimen = list.form_name;
      if (!a.includes(specimen)) {
        const reports = lists.filter((ele) => ele.form_name === specimen);
        b.push({ specimen, reports });
        a.push(specimen);
      }
    }


    this.specimenList = b;
    // this.getCorrectSpeci1()
  }
  /* THIS CODE IS TO REPLACE WORNG NAMES SPELT IN THE PERFORMANCE FORM */
  /**
   * It filters the staffList array to only include the elements that have a created_at date that is equal to or after the
   * from date and equal to or before the to date
   * @param {Event} $event - Event - The event object that is passed to the function when the form is submitted.
   */
  onIntervalSubmit($event: Event) {
    $event.preventDefault();
    const fromVal = $("#from").val();
    const toVal = $("#to").val();


    if (fromVal !== "" && toVal !== "") {
      this.searchVal = true;
      this.loading = true;


      /* Converting the date to a string and then converting it back to a date. */
      const from = new Date(new Date(fromVal).toDateString());
      const to = new Date(new Date(toVal).toDateString());


      this.fromDate = from.toDateString();
      this.toDate = to.toDateString();


      /* Filtering the tatList array to only include the elements that have a created_at date that is equal to or after the
     from date and equal to or before the to date. */
      this.searchedPerformanceList = this.performanceList.filter((ele) => {
        const createdAt = new Date(new Date(ele.created_at).toDateString());
        return (
          (isEqual(from, createdAt) || isAfter(createdAt, from)) &&
          (isEqual(to, createdAt) || isBefore(createdAt, to))
        );
      });
      this.getSpecimenList();
      this.getServiceCluster();
      this.loading = false;
    } else {
      this.generalService.emptyDateFieldError();
    }
  }


  /**
   * The function clears the search fields and resets the search results to the original list
   */

  clear() {
    // $("newStartDate")("");
    // $("newEndDate")("");
    this.newStartDate = (" ")
    this.newEndDate = (" ")
    this.searchVal = false;
    // this.searchedPerformanceList = this.yearlyPerformanceList;
    this.getInputDate();
    this.getTotalDisplay();
    this.getAllServiceClusters();
    this.detailedItem();
    // this.changeOrder();
  }


  /**
   * It takes an array of objects, loops through the array, and adds the value of the total_amount property of each object
   * to a variable
   * @param {any} lists - any - this is the array of objects that you want to get the total amount from.
   * @returns The total amount of all the lists.
   */
  getBilled(lists: any) {
    let a = 0;
    for (const list of lists) {
      a += list.total_amount;
    }


    return a;
  }


  /**
   * It takes an array of objects, loops through the array, and adds the amount_paid property of each object to a variable
   * @param {any} lists - any - this is the array of objects that you want to get the total of.
   * @returns The total amount paid for all the lists.
   */
  getPaid(lists: any) {
    let a = 0;
    for (const list of lists) {
      a += list.amount_paid;
    }


    return a;
  }


  /**
   * It takes an array of objects, loops through the array, and adds the value of the arreas property of each object to a
   * variable
   * @param {any} lists - any - this is the array of objects that we are going to loop through.
   * @returns The total amount of arrears for all the lists.
   */
  getArrears(lists: any) {
    let a = 0;
    for (const list of lists) {
      a += list.arreas;
    }


    return a;
  }


  view(selected) {
    this.selectedSpecimen = selected;


    this.viewModal.show();
  }


  /**
   * This function is used to get the company profile data from the database
   */
  getComProfile() {
    // this.spinner.show();
    this.auth.get("facility_profile").subscribe(
      (response: any) => {
        if (response.company !== null) {
          this.companyData = response.company;
        }
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }


  /**
   * We're creating a new div element, appending it to the body, copying the contents of the element we want to print into
   * the new div, printing the new div, and then removing the new div from the body
   */
  printElement() {
    const elem = document.getElementById("contentToPrint");
    const domClone = elem.cloneNode(true);


    const $printSection = document.createElement("div");
    $printSection.style.padding = "15px 5px";
    $printSection.id = "printSection";
    document.body.appendChild($printSection);


    $printSection.innerHTML = "";
    $printSection.appendChild(domClone);
    window.print();
    $printSection.style.padding = "0px";
    $printSection.innerHTML = "";
  }


  /**
   * It takes a list of objects, and returns a list of objects with the same properties, but with the values of the
   * properties calculated from the original list
   */
  getServiceCluster() {
    const a = [];
    const b = [];

    for (const search of this.searchedPerformanceList) {


      const service = JSON.parse(search?.service_type);


      if (service && service?.service_type !== null) {


        if (a.includes(service[0].service_type)) {


          for (let serve of b) {


            if (serve.cluster == service[0].service_type) {
              serve.billed += search.total_amount;
              serve.paid += search.amount_paid
              serve.arrears += search.arreas
            }
          }
        } else {
          b.push({
            cluster: service[0].service_type,
            billed: search.total_amount,
            paid: search.amount_paid,
            arrears: search.arreas,
          });
          a.push(service[0].service_type);
        }
      }


      // }


    }
    this.clusters = b;
  }


  getInputDate() {
    this.searchVal = true;


    const handleResponse = (response: any, context: string) => {
      this.spinner.hide();
      Swal.close();
      Swal.fire('Success', `Item performance fetched for ${context}.`, 'success');


      this.detailedItem = [];
      this.getAllServiceClusters = response['service_cluster'];
      this.getAllBilling = response['billing'];
      this.getIndexedData();
    };


    const handleError = (context: string) => {
      this.spinner.hide();
      Swal.close();
      Swal.fire('Error', `Failed to fetch item performance for ${context}.`, 'error');
    };


    if (this.newStartDate && !this.newEndDate) {
      this.spinner.show();
      Swal.fire({ title: 'Loading...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });


      this.auth.get(`item_performance?start_date=${this.newStartDate}&${this.tab}=${this.tab}`).subscribe({
        next: (response: any) => handleResponse(response, 'Start Date only'),
        error: () => handleError('Start Date')
      });


    } else if (this.newEndDate && !this.newStartDate) {
      this.spinner.show();
      Swal.fire({ title: 'Loading...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });


      this.auth.get(`item_performance?end_date=${this.newEndDate}&${this.tab}=${this.tab}`).subscribe({
        next: (response: any) => handleResponse(response, 'End Date only'),
        error: () => handleError('End Date')
      });


    } else if (this.newStartDate && this.newEndDate) {
      this.spinner.show();
      Swal.fire({ title: 'Loading...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });


      this.auth.get(`item_performance?start_date=${this.newStartDate}&end_date=${this.newEndDate}&${this.tab}=${this.tab}`).subscribe({
        next: (response: any) => handleResponse(response, 'Date Range'),
        error: () => handleError('Date Range')
      });


    } else {
      Swal.fire('Input Required', 'Please enter at least one date.', 'warning');
    }
  }
}
